export default "__VITE_ASSET__qf52vOkX__"